module.exports={"flag":"","geoJSON":{},"ISO":{"alpha2":"","alpha3":"ANT"},"provinces":["Netherlands Antilles"],"tld":[],"wiki":"http://en.wikipedia.org/wiki/Netherlands_Antilles"}
